import React, { useEffect } from 'react';


const OtpFiller = (props) => {
    useEffect(() => {
        for (let i = 1; i <= props.length; i++) {
            let _otp = "";
            const input = document.getElementById(`otp_block_${i}`);
            input.setAttribute('maxlength', 1);
            input.onkeyup = (e) => {
                if (e.keyCode === 8 || e.keyCode === 37) {
                    var prev = document.getElementById(e.target.getAttribute('data-previous'));
                    if (prev) {
                        prev.select();
                    }
                } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
                    var next = document.getElementById(e.target.getAttribute('data-next'));
                    if (next.id !== input.id) {
                        next.select();
                    }
                }
                for (let i = 1; i <= props.length; i++) {
                    const input = document.getElementById(`otp_block_${i}`);
                    _otp += input.value;
                }
                props.onChange(_otp);
            }
        }
    })

    const renderTextBoxes = () => {
        const comp = [];
        for (let i = 1; i <= props.length; i++) {
            comp.push(<input
                onChange={(e) => { }}
                id={`otp_block_${i}`}
                data-next={`otp_block_${i === props.length ? props.length : i + 1}`}
                data-previous={`otp_block_${i === 1 ? 1 : i - 1}`}
                style={{ width: 45, fontSize: 30, border: 'none', borderBottom: "2px solid #ddd", marginRight: 20, outline: 'none', textAlign: 'center' }}
            />);
        }
        return comp;
    }
    return (
        <div className="text-center">
            {renderTextBoxes(props.length)}
        </div>
    )
}


OtpFiller.defaultProps = {
    length: 6,
    onChange: () => { }
}

export default OtpFiller;